import { SubjectData } from 'shell/models/person';
import { AccordionGeneralityForm } from 'civil-status/view-models/accordion-generality-form';
import { ParentVM, SectionVM } from 'civil-status/view-models/step-form';
import { transformerActBorn } from './transformer-act-born';
import { transformerSpouse } from './transformer-spouse';
import { transformerGenerality } from './transformer-generality';
import { SearchPersonType } from 'civil-status/components/step/form/last-step/accordions/subject';
import { transformerCivilUnionSpouse } from './transformer-civil-union-spouse';
import { transformerParent } from './transformer-parent';

export const transformerSearchPerson = (person: SubjectData): SearchPersonType => {
  const generalityReturn: AccordionGeneralityForm | undefined = transformerGenerality(person);

  const actBornReturn: SectionVM | undefined = person.attoNascitaANPR
    ? transformerActBorn(person)
    : undefined;

  const spouseReturn: ParentVM | undefined = person.matrimonio
    ? transformerSpouse(person)
    : undefined;

  const civilUnionSpouseReturn: ParentVM | undefined = person.unioneCivile
    ? transformerCivilUnionSpouse(person)
    : undefined;

  const fatherReturn: ParentVM | undefined = person.paternita
    ? transformerParent(person.paternita)
    : undefined;

  const motherReturn: ParentVM | undefined = person.maternita
    ? transformerParent(person.maternita)
    : undefined;

  return {
    generality: generalityReturn,
    actBorn: actBornReturn,
    spouse: spouseReturn,
    civilUnionSpouse: civilUnionSpouseReturn,
    father: fatherReturn,
    mother: motherReturn,
  };
};
